import './App.css';
import {
  Anchor,
  Badge,
  Button,
  Card,
  Checkbox,
  CheckboxProps,
  Col,
  Divider,
  Dropdown,
  Flex,
  Form,
  MenuProps,
  message,
  Modal,
  Row,
  Select,
  Skeleton,
  Space,
  Statistic,
  Typography,
} from 'antd';
import useSWR, { useSWRConfig } from 'swr';
import 'react-quill/dist/quill.snow.css';
import cookie from 'react-cookies';

import { useNavigate } from 'react-router-dom';
import { DownOutlined, LeftCircleOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';

import { usePageAnimation } from './AnimationContext';

const { Title } = Typography;

const fetcher = async (url: string) => {
  const token = cookie.load('token');
  const res = await fetch(url, {
    headers: new Headers({
      'Access-Control-Allow-Origin': '*',
      Authorization: `Bearer ${token}`,
    }),
  });
  const json = await res.json();
  if (!json.success) {
    const error = new Error((await json).message);
    throw error;
  }
  return json;
};

const MarshmallowCard = ({
  data,
  editMode,
  checkedList,
  setCheckedList,
  categories,
  lastRead
}: any) => {
  const n = useNavigate();
  const { mutate } = useSWRConfig();
  const token = cookie.load('token');
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editForm] = Form.useForm();
  const checked =
    checkedList.find((item: any) => item === data.id) !== undefined;
  const onChange: CheckboxProps['onChange'] = e => {
    if (checked) {
      const newCheckedList = checkedList.filter(
        (item: any) => item !== data.id
      );
      setCheckedList(newCheckedList);
    } else {
      setCheckedList([...checkedList, data.id]);
    }
  };
  const deleteMarshmallow = async () => {
    setDeleteOpen(false);
    const response = await (
      await fetch('https://api.lynne.com.cn/marshmallowManage/delete', {
        method: 'POST',
        body: JSON.stringify({
          id: data.id,
        }),
        headers: new Headers({
          'Access-Control-Allow-Origin': '*',
          'Content-type': 'Application/json',
          Authorization: `Bearer ${token}`,
        }),
      })
    ).json();
    if (response.success) {
      message.success(response.message);
      mutate(`https://api.lynne.com.cn/marshmallowManage/listArchived`);
      mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
    } else {
      message.error(response.message);
    }
  };
  const items: MenuProps['items'] = [
    {
      label: '删除此稿件',
      key: '4',
    },
    {
      label: '取消收纳此稿件',
      key: '5',
    },
  ];
  const handleMenuClick: MenuProps['onClick'] = async e => {
    if (e.key === '4') {
      setDeleteOpen(true);
    } else if (e.key === '5') {
      const response = await (
        await fetch('https://api.lynne.com.cn/marshmallowManage/archive', {
          method: 'POST',
          body: JSON.stringify({
            id: data.id,
            archived: 0,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        })
      ).json();
      if (response.success) {
        message.success(response.message);
        mutate(`https://api.lynne.com.cn/marshmallowManage/listArchived`);
        mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      } else {
        message.error(response.message);
      }
    }
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };
  return (
    <>
      <Modal
        open={deleteOpen}
        title='删除投稿'
        okText='删除'
        okType='danger'
        cancelText='取消'
        onCancel={() => setDeleteOpen(false)}
        destroyOnClose
        onOk={() => deleteMarshmallow()}
        >
        确定要删除这个投稿吗？
      </Modal>
      <Dropdown menu={menuProps} trigger={['contextMenu']}>
        <Card
          className="marshmallow-card"
          hoverable
          bordered={false}
          style={{ width: '100%' }}
          onClick={() => {
            if (editMode) {
              if (checked) {
                const newCheckedList = checkedList.filter(
                  (item: any) => item !== data.id
                );
                setCheckedList(newCheckedList);
              } else {
                setCheckedList([...checkedList, data.id]);
              }
            } else {
              // 获取当前页面滚动参数并自动保存至session
              const scrollData =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop ||
                window.scrollY ||
                0;
              sessionStorage.setItem('scrollArchived', scrollData.toString());
              sessionStorage.setItem('lastReadArchived', data.id.toString());
              n(`/dashboard/archived/${data.id}`);
            }
          }}>
          <Space style={{ width: '100%' }}>
            {editMode && <Checkbox checked={checked} onChange={onChange} />}
            {data.title}
            {
              lastRead === data.id && <Badge color='purple' count='上次阅读到这篇喔' />
            }
          </Space>
        </Card>
      </Dropdown>
    </>
  );
};

const MarshmallowCategoryCard = ({ marshmallow, categories, lastRead }: any) => {
  const { mutate } = useSWRConfig();
  const token = cookie.load('token');
  const [editMode, setEditMode] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [editForm] = Form.useForm();
  const [checkedList, setCheckedList] = useState<number[]>([]);
  const deleteMarshmallow = async () => {
    setDeleteOpen(false);
    let flag = true;
    for (let id of checkedList) {
      const response = await (
        await fetch('https://api.lynne.com.cn/marshmallowManage/delete', {
          method: 'POST',
          body: JSON.stringify({
            id: id,
          }),
          headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            'Content-type': 'Application/json',
            Authorization: `Bearer ${token}`,
          }),
        })
      ).json();
      if (response.success) {
      } else {
        message.error(response.message);
        flag = false;
        break;
      }
    }
    if (flag) {
      message.success('删除成功');
    }
    mutate(`https://api.lynne.com.cn/marshmallowManage/listArchived`);
    mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
    setCheckedList([]);
  };
  const handleMenuClick: MenuProps['onClick'] = async e => {
    if (checkedList.length === 0) {
      message.error('笨蛋！明明一个都没有选中！');
      return;
    }
    if (e.key === '4') {
      setDeleteOpen(true);
    } else if (e.key === '5') {
      let flag = true;
      for (let id of checkedList) {
        const response = await (
          await fetch('https://api.lynne.com.cn/marshmallowManage/archive', {
            method: 'POST',
            body: JSON.stringify({
              id: id,
              archived: 0,
            }),
            headers: new Headers({
              'Access-Control-Allow-Origin': '*',
              'Content-type': 'Application/json',
              Authorization: `Bearer ${token}`,
            }),
          })
        ).json();
        if (response.success) {
        } else {
          message.error(response.message);
          flag = false;
          break;
        }
      }
      mutate(`https://api.lynne.com.cn/marshmallowManage/listArchived`);
      mutate(`https://api.lynne.com.cn/marshmallowManage/category`);
      if (flag) {
        message.success('设置成功');
      }
      setCheckedList([]);
    }
  };
  const items: MenuProps['items'] = [
    {
      label: '批量删除',
      key: '4',
    },
    {
      label: '批量取消收纳',
      key: '5',
    },
  ];

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const selectAll = () => {
    if (checkedList.length === marshmallow.data.length) {
      setCheckedList([]);
    } else {
      setCheckedList(marshmallow.data.map((item: { id: any }) => item.id));
    }
  };
  return (
    <>
      <Modal
        open={deleteOpen}
        title='批量删除'
        okText='删除'
        okType='danger'
        cancelText='取消'
        onOk={() => deleteMarshmallow()}
        onCancel={() => setDeleteOpen(false)}
        destroyOnClose
        >
        真的要删除这{checkedList.length}个棉花糖投稿吗（不用担心误删，拾雨每天有备份数据）
      </Modal>
      <Card
        title={marshmallow.category}
        bordered={false}
        style={{ width: '100%' }}
        extra={
          editMode ? (
            <Space>
              <Button onClick={() => setEditMode(false)}>退出批量操作</Button>
              <Button onClick={() => selectAll()}>
                {checkedList.length === marshmallow.data.length
                  ? '全不选'
                  : '全选'}
              </Button>
              <Dropdown menu={menuProps}>
                <Button type='primary'>
                  <Space>
                    操作
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            </Space>
          ) : (
            <Button onClick={() => setEditMode(true)}>批量操作</Button>
          )
        }>
        <Space direction='vertical' size={'middle'} style={{ width: '100%' }}>
          {marshmallow.data.map((item: { id: any }) => {
            return (
              <MarshmallowCard
                lastRead={lastRead}
                key={item.id}
                data={item}
                editMode={editMode}
                checkedList={checkedList}
                setCheckedList={setCheckedList}
                categories={categories}
              />
            );
          })}
        </Space>
      </Card>
    </>
  );
};

const ArchivedList = () => {
  const { data, error, isLoading } = useSWR(
    'https://api.lynne.com.cn/marshmallowManage/listArchived',
    fetcher
  );
  const {
    data: categoryData,
    error: categoryError,
    isLoading: categoryIsLoading,
  } = useSWR('https://api.lynne.com.cn/marshmallowManage/category', fetcher);
  const n = useNavigate();
  const isAnimationComplete = usePageAnimation();
  const [lastRead, setLastRead] = useState(0);
  useEffect(() => {
    // 登录校验
    if (cookie.load('token') === undefined) {
      n('/login');
      return;
    }
    if (isLoading || categoryIsLoading || !data || !isAnimationComplete) {
      return;
    }

    const scroll = sessionStorage.getItem('scrollArchived');
    const last = sessionStorage.getItem('lastReadArchived');
    if (last) {
      setLastRead(parseInt(last));
      sessionStorage.removeItem('lastReadArchived');
    }
    if (scroll) {
      const targetY = parseInt(scroll, 10);
      
      // 这里依然建议保留一个微小的延时 (0ms 或 10ms)
      // 因为 React Context 更新导致重渲染到 DOM 稳定可能需要一帧的时间
      // 但不需要设为 500ms 那么长了
      requestAnimationFrame(() => {
        console.log("执行恢复滚动:", targetY);
        
        window.scrollTo({
          top: targetY,
          behavior: 'smooth' // <--- 关键：开启平滑滚动
        });
        sessionStorage.removeItem('scrollArchived');
      });
    }
  }, [
    n, 
    isLoading, 
    categoryIsLoading, 
    data, 
    isAnimationComplete // <--- 别忘了把这个加入依赖数组
  ]);

  if (isLoading || categoryIsLoading || data === undefined)
    return <Skeleton active />;
  if (error || categoryError) {
    if (
      (error.message && error.message.includes('无效登录')) ||
      (categoryError.message && categoryError.message.includes('无效登录'))
    ) {
        message.error("好像出错了喵");
    }
  }
  
  const marshmallows = [];
  const marshmallowCategories: any[] = [];
  const anchors = [];
  const categories: { value: any; label: any }[] = [];
  for (let i = 0; i < categoryData.data.length; i++) {
    categories.push({
      value: categoryData.data[i].id,
      label: categoryData.data[i].name,
    });
  }
  for (let i = 0; i < data.data.length; i++) {
    if (marshmallowCategories.indexOf(data.data[i].category) === -1) {
      marshmallowCategories.push(data.data[i].category);
      marshmallows.push({
        categoryId: data.data[i].category,
        category: data.data[i].name,
        data: [data.data[i]],
      });
      anchors.push({
        key: `part${data.data[i].category}`,
        href: `#part${data.data[i].category}`,
        title: data.data[i].name,
      });
    } else {
      marshmallows[
        marshmallowCategories.indexOf(data.data[i].category)
      ].data.push(data.data[i]);
    }
  }
  // 渲染数据
  return (
    <>
      <Flex align='center' gap={10}>
        <Button
          type='primary'
          shape='circle'
          icon={<LeftCircleOutlined />}
          onClick={() => n('/dashboard/category')}
        />
        <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
          收纳箱管理
        </Title>
      </Flex>
      <Divider />
      <Space direction='vertical' size={'middle'} style={{ width: '100%' }}>
        <Anchor
          direction='horizontal'
          items={anchors}
          targetOffset={25}
          className="anchor"
          style={{
            padding: '2px 15px',
            borderRadius: '8px',
          }}
        />
        {marshmallows.map(marshmallow => {
          return (
            <div
              id={`part${marshmallow.categoryId}`}
              key={marshmallow.category}>
              <MarshmallowCategoryCard
                lastRead={lastRead}
                marshmallow={marshmallow}
                categories={categories}
              />
            </div>
          );
        })}
      </Space>
    </>
  );
};

export default ArchivedList;
